export default __webpack_public_path__ + "static/media/app_listen_notes.c0d066fe.svg";